import isPlainObject from 'lodash/isPlainObject';

export const removeNullDeep = value => {
  if (Array.isArray(value)) return value.filter(val => val !== null).map(removeNullDeep);
  if (!isPlainObject(value)) return value;

  return Object.fromEntries(
    Object.entries(value)
      .filter(([, val]) => val !== null)
      .map(([key, val]) => [key, removeNullDeep(val)])
  );
};
